module.exports = __webpack_public_path__ + "static/instagram-fe084382d58ac6138f632e920dc428fd.png";